import React, {useEffect, useState} from 'react';
import {Tabs, Spin, Button} from 'antd';
import CanBusRedCard from './CanBusRedCard';
import CanBusYellowCard from './CanBusYellowCard';
import {io} from 'socket.io-client';
import {useSelector} from 'react-redux';
import * as XLSX from 'xlsx';
import {FileExcelOutlined} from "@ant-design/icons";
import {getTTName} from "../../../components/getTTName";

const Index = () => {

    const [canMergedData, setCanMergedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('1');
    const {user} = useSelector((state) => state.auth);

    useEffect(() => {
        const socket = io('https://live.myoctoopidev.com', {
            reconnection: true,
            transports: ['websocket'],
            reconnectionDelay: 2000,
            reconnectionAttempts: 5,
            withCredentials: true,
            query: {'x-access-token': user?.token},
            transportOptions: {binary: true},
        });

        socket.on('canMergedData', (incomingData) => {
            setCanMergedData(incomingData);
            setLoading(false);
        });

        socket.on('reconnect', () => console.log('Yeniden bağlandınız'));
        socket.on('connect_error', (error) => console.log('Bağlantı hatası:', error.name));

        return () => socket.disconnect();
    }, [user?.token]);

    const items = [
        {
            key: '1',
            label: 'Can Bus Uyarı',
            children: (
                <CanBusYellowCard
                    data={canMergedData.filter((data) => data.conditionYellowDetails?.length > 0)}
                />
            ),
        },
        {
            key: '2',
            label: 'Can Bus Arıza',
            children: (
                <CanBusRedCard
                    data={canMergedData.filter((data) => data.conditionRedDetails?.length > 0)}
                />
            ),
        },
    ];

    const onChange = (key) => {
        setActiveTab(key);
    };

    const handleExportToExcel = () => {
        let exportData = [];

        if (activeTab === '1') {
            exportData = canMergedData
                .filter((data) => data.conditionYellowDetails?.length > 0)
                .map((item) => ({
                    plateNumber: item.plateNumber,
                    operationNumber: item.operationNumber,
                    vehicleId: item.vehicleId,
                    chassisNumber: item.chassisNumber,
                    conditionDetails: item.conditionYellowDetails,
                }));
        } else if (activeTab === '2') {
            exportData = canMergedData
                .filter((data) => data.conditionRedDetails?.length > 0)
                .map((item) => ({
                    plateNumber: item.plateNumber,
                    operationNumber: item.operationNumber,
                    vehicleId: item.vehicleId,
                    chassisNumber: item.chassisNumber,
                    conditionDetails: item.conditionRedDetails,
                }));
        }

        if (exportData.length === 0) {
            console.log('Export edilecek veri bulunamadı.');
            return;
        }

        const formattedData = exportData.flatMap((item) =>
            item.conditionDetails.map((detail) => ({
                'Uyarı İsmi': getTTName(detail.tt_id, detail.tts) || 'Bilinmeyen',
                'Plaka Numarası': item.plateNumber,
                'Kapı Numarası': item.operationNumber,
                'Şase Numarası': item.chassisNumber,
                'Grup': ' '
            }))
        );

        formattedData.sort((a, b) => a['Uyarı İsmi'].localeCompare(b['Uyarı İsmi']));

        const headerData = [
            {A: `Rapor Tarihi: ${new Date().toLocaleString('tr-TR')}`},
            {A: `Raporu Oluşturan: ${user?.name || 'Bilinmiyor'}`},
            {A: `Rapor Türü:  Servis & Bakım`},
            {},
        ];

        const worksheet = XLSX.utils.json_to_sheet([]);

        XLSX.utils.sheet_add_json(worksheet, headerData, {skipHeader: true, origin: 'A1'});
        XLSX.utils.sheet_add_json(worksheet, formattedData, {origin: 'A5'});

        worksheet['!cols'] = formattedData.length
            ? Object.keys(formattedData[0]).map((key) => ({
                wch: Math.max(
                    ...formattedData.map((row) => (row[key] ? row[key].toString().length : 0)),
                    key.length
                ) + 2,
            }))
            : [];

        worksheet['!rows'] = [
            {level: 0},
            {level: 0},
            {level: 0},
            {level: 1, bold: true},
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Can Bus Dashboard');

        XLSX.writeFile(
            workbook,
            `CanBus_Rapor_${activeTab === '1' ? 'Uyarı' : 'Arıza'}_${new Date()
                .toISOString()
                .slice(0, 10)}.xlsx`
        );
    };

    return (
        <Spin spinning={loading} tip="Veriler yükleniyor...">
            <Tabs
                activeKey={activeTab}
                onChange={onChange}
                defaultActiveKey="1"
                items={items}
                tabBarExtraContent={
                    <Button type="dashed" icon={<FileExcelOutlined/>} onClick={handleExportToExcel}>
                        Raporla
                    </Button>
                }
            />
        </Spin>
    );
};

export default Index;
